import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const LonelinessGraphStyles = styled(OnboardingPage)`
  ion-content {
    .loneliness-graph-title {
      margin-bottom: 0;
    }

    .img-container {
      width: 100%;
      max-width: 240px;
      margin: 0 auto;

      @media screen and (min-width: 576px) {
        max-width: 300px;
        margin: 20px auto 0;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .description {
      margin: 0 auto 0;
      text-align: center;
      padding: 0 16px;
    }
  }
`;
